<div class="filter-layout">
  @if (showHeading) {
  <div class="fl-header">
    <p class="f-14 font-weight-600 mb-0">Hiring Criteria</p>
    <div class="d-flex align-items-center">
      <div class="d-flex align-items-center">
        <button data-testid="auto-app-hiring-criteria-button-1" class="hire-btn-secondary mr-3" (click)="cancel()">Cancel</button>
           <div class="dropdown" *ngIf="!firstTime">
          <button data-testid="auto-app-hiring-criteria-button-2" class="hire-btn-primary dropdown-toggle" role="button" data-bs-toggle="dropdown" aria-expanded="false"
           >Explore Candidates</button>
          <div class="dropdown-menu">
            <div class="p-3">
              <p class="f-16 font-weight-500 mb-1">Refresh Candidate Results?</p>
              <p class="f-14 font-weight-400 text-9696 mb-2">Applying these criteria will replace the candidate list with
                newly
                matched results based on your updated criteria</p>
              <div class="d-flex">
                <button data-testid="auto-app-hiring-criteria-button-3" class="btn-trms-gray">
                  Cancel
                </button>
                <button data-testid="auto-app-hiring-criteria-button-4" class="btn-trms-medium ml-1" (click)="exploreCandidates()"
                  >
                  Update results
                </button>
              </div>
            </div>
          </div>
        </div>
          <button data-testid="auto-app-hiring-criteria-button-5" class="hire-btn-primary dropdown-toggle" *ngIf="firstTime" role="button" data-bs-toggle="dropdown" aria-expanded="false" (click)="exploreCandidates()"
           >Explore Candidates</button>

        <!-- <button data-testid="auto-app-hiring-criteria-button-6" class="hire-btn-primary" [ngClass]="{'disabled': !hasChanges}" [disabled]="!hasChanges" (click)="exploreCandidates()">Explore Candidates</button> -->
      </div>
    </div>
  </div>
}

<div class="fl-container">
  <div class="criteria-body">
    <form [formGroup]="criteriaForm">
      <p>What should AI evaluate candidates for? Add up to 5 criteria to guide AI candidate evaluation.</p>

      <div
        cdkDropList
        class="example-list"
        formArrayName="criterias"
        (cdkDropListDropped)="drop($event)"
      >
        @for (criteria of criterias.controls; track criteria; let i = $index) {
          <div class="example-box" cdkDrag>
            <span class="mr-2 cursor-move">
              <i class="fa-solid fa-grip-vertical f-20 text-9696"></i>
            </span>
            <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
            <span class="new-criteria-card">
              <span class="label-criteria">
                Criteria {{ i + 1 }}
              </span>
              <span class="criteria-input">
                <input data-testid="auto-app-hiring-criteria-input-1"
                  type="text"
                  [formControlName]="i"
                  placeholder="Type your own criteria..."
                  class="wc-form-control"
                  #criteriaInput
                  (keyup.enter)="onEnter(i)"
                />
              </span>
              @if (criteria.value?.trim()) {
                <span class="criteria-trash pointer" (click)="removeCriteria(i)">
                  <i class="far fa-trash f-14" style="color: #EC221F;"></i>
                </span>
              }
            </span>
          </div>
        }
      </div>

      @if (aiSuggestedCriterias?.length) {
        <div>
          <div class="d-flex align-items-center justify-content-start mb-4">
            <p class="mb-0 gen-ai-text">AI Suggested Criteria's </p>
          </div>
          <div>
            <div class="ai-chip-container">
              <span>
                @for (suggestion of visibleSuggestions; track suggestion; let si = $index) {
                  <ng-container>
                    <p
                      class="ai-screening-chips"
                      [class.disabled]="!hasEmptySlot"
                      (click)="addFromSuggestion(si)"
                    >
                      <span class="gedient-criteria">
                        <i class="fa-solid fa-plus mr-2"></i>
                        <span>{{ suggestion }}</span>
                      </span>
                    </p>
                  </ng-container>
                }
              </span>
            </div>
          </div>
        </div>
      }

      @if (!showHeading) {
        <div class="d-flex justify-content-end mt-5">
          <button data-testid="auto-app-hiring-criteria-button-7" class="btn-trms-gray mr-3">Skip</button>
          <button data-testid="auto-app-hiring-criteria-button-8" class="btn-trms-small" (click)="goToProjectList()">Explore Candidates</button>
        </div>
      }
    </form>
  </div>
</div>


</div>
